import * as React from "react";
import { UitkHeading } from "uitk-react-text";

export const CardTitle = ({ cardTitle }: { cardTitle: string }) => (
  <UitkHeading size={500} overflow="truncate" level={3}>
    {cardTitle}
  </UitkHeading>
);
